module.exports = __webpack_public_path__ + "img/instructions-1.b1b455f4.png";